import {
  BROADCAST_CHANNEL_NAMES,
  KizenBroadcastChannel,
} from 'utility/KizenBroadcastChannel';

export const BLOCKER_DATA_TYPES = {
  change_business: 'change-business',
  log_out: 'log-out',
  session_timeout: 'session-timeout',
  force_logout: 'force-logout',
} as const;

const BlockerDataTypes = Object.values(BLOCKER_DATA_TYPES);

type BlockerDataType = (typeof BlockerDataTypes)[number];

export type ShowBlockerData = {
  type: BlockerDataType;
  senderId: string;
  state?: boolean;
};

export const getShowBlockerBroadcastChannel = (
  onMessage: (data: ShowBlockerData) => void
) => {
  const bc = new KizenBroadcastChannel<ShowBlockerData>(
    BROADCAST_CHANNEL_NAMES.auth_user_session
  );
  bc.onmessage = (e) => {
    onMessage(e.data);
  };

  return bc;
};

export const postShowBlockerMessage = (data: ShowBlockerData) => {
  const bc = new KizenBroadcastChannel<ShowBlockerData>(
    BROADCAST_CHANNEL_NAMES.auth_user_session
  );
  bc.postMessage(data);
  bc.close();
};

export const postSessionTimeoutMessage = (senderId: string) => {
  postShowBlockerMessage({
    type: BLOCKER_DATA_TYPES.session_timeout,
    senderId,
  });
};

export const postChangeBusinessMessage = (senderId: string) => {
  postShowBlockerMessage({
    type: BLOCKER_DATA_TYPES.change_business,
    senderId,
  });
};

export const postLogOutMessage = (senderId: string) => {
  postShowBlockerMessage({
    type: BLOCKER_DATA_TYPES.log_out,
    senderId,
  });
};

export const postForceLogOutMessage = (senderId: string) => {
  postShowBlockerMessage({
    type: BLOCKER_DATA_TYPES.force_logout,
    senderId,
  });
};
